import classes from './Warning.module.css';

export default function Warning({ text }) {
  return (
    <div className={classes["warning-box"]}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
      </svg>
      <span>{text}</span>
    </div>
  );
}
